<template>
  <div
    class="dropdown-2"
    :style="{
      '--bb': bb || `1px solid var(--sprt-85)`,
      '--fc2-lw': lw,
      '--fc2-cw': cw,
    }"
  >
    <!-- <label v-if="showLabel" class="txtov" :title="label">{{ label }}</label> -->
    <label v-if="showLabel" class="txtov" :title="label" :for="id">
      <span>{{ label }}</span>
      <img
        v-if="hint"
        class="dt-icon v5 s20 fc2-hint"
        :title="hint"
        src="static/icons/help.svg"
        :alt="hint"
      />
    </label>

    <Dropdown
      v-bind="$props"
      @selectedChange="(value) => $emit('selectedChange', value)"
      @searchedBlur="(value) => $emit('searchedBlur', value)"
      @searched="(value) => $emit('searched', value)"
    >
    </Dropdown>
  </div>
</template>

<script>
import { dropdownProps } from "./dropdown.vue";
import { FC2Mixin } from "../fc2";
import { FC2CommonProps } from "../fc2/fc2.vue";
export default {
  props: {
    ...dropdownProps,
    label: {
      type: String,
    },
    value: {
      required: false,
    },
    id: {
      required: false,
    },
  
    hint: {
      type: String,
    },

    ...FC2CommonProps,
  },
  mixins: [FC2Mixin()],
};
</script>
<style lang="scss">
.dropdown-2 {
  display: flex;
  height: 32px;
  border-bottom: var(--bb);

  --fc2-bdc: transparent;
  --fc2-disabled-bc: hsla(0, 0%, 94%, 1);
  // --fc2-bc: transparent;

  --d2-margin: 3px 3px 3px 0px;
  --d2-margin-focus: -1px 3px -1px 0px;
  --d2-padding: 0px 0 0 10px;
  --d2-padding-focus: 0px 0 0 10px;
  /* --d2-padding-focus: 4px 0 0 10px; */

  &.dbox1 {
    --d2-margin: 3px 3px 3px 3px;
    --d2-padding: 0px 0 0 7px;
    --d2-padding-focus: 0px 3px 0 10px;
    --d2-margin-focus: 0px 0px 0px 0px;
    /* --d2-padding-focus: 4px 3px 0 10px;
    --d2-margin-focus: 0px 0px 0px 0px; */
  }
  & > .dropdown {
    & > .layout.row.wrap {
      height: 100%;
      & > .flex.md12 {
        height: 100%;
        & > .menu {
          height: 100%;
        }
      }
    }
  }

  label {
    min-width: var(--fc2-lw);
    width: var(--fc2-lw);

    display: flex;
    color: var(--text-5);
    margin: 0px 10px 0px 10px;
    // padding-top: 5px;
    padding-top: 5px;
    padding-bottom: 6px;

    justify-content: space-between;
  }
  .dropdown {
    min-width: 0px;

    flex: 1;
    padding-left: 7px;

    border-radius: 4px;
    border: 1px solid;

    border-color: var(--fc2-bdc);
    background-color: var(--fc2-bc);

    padding: var(--d2-padding);
    margin: var(--d2-margin);

    &:hover {
      --fc2-bdc: var(--bc-cblue5);
      --fc2-bc: var(--bc-cblue);
    }

    &.disabled:not(.dbox1) {
      // Undoing the Dropdown Component Disabled Style Opacity
      opacity: 1;
      // Assigning the Disabled BC
      --fc2-bc: var(--fc2-disabled-bc);

      border-color: hsla(0, 0%, 94%, 1);
      &:hover {
        border-color: hsla(0, 0%, 80%, 1);
      }
    }

    &:active,
    &:focus {
      --fc2-bdc: var(--bc-cblue10);
      margin: var(--d2-margin-focus);
      padding: var(--d2-padding-focus);

      border-radius: 0px;
    }

    .dropdown--main {
      padding: 0px;

      height: 100%;
      .dropdown--main__icon {
        margin-right: 2px;
        .dt-icon-container {
          height: 100%;
          img.dt-icon.s1 {
            width: 23px;
            height: 23px;
          }
        }
      }

      .placeholder {
        color: var(--text-primary);
        opacity: 0.25;
      }
    }
  }
}

// As Per Simo Requirement -- Disabled Controls Inside the DT Grid Box will be only disabled
// when The Parent Box is Hovered on.
// By Default they will be normal Looking

.dt-grid-box {
  .dropdown-2.dbox1 {
    .dropdown.disabled {
      --fc2-bc: transparent;
      border-color: transparent;
    }
  }
  &:hover {
    .dropdown-2.dbox1 {
      opacity: 1; //TODO: Why is this needed ? (Something to do with HTML Placeholder ?) Need to Figure out Later
      .dropdown.disabled {
        --fc2-bc: transparent;
        --fc2-bc: var(--fc2-disabled-bc);

        --default-hover-bc: var(--fc2-disabled-bc);
        --default-hover-bdc: var(--fc2-disabled-bdc);
      }
    }
  }
}
</style>